var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"list-group-item list-group-item-action",attrs:{"href":_vm.approval.url}},[_c('small',[_vm._v(_vm._s(_vm.$t('Requisition')))]),_vm._v(" "),_c('h5',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.approval.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e2bcad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Approval/ApprovalListItem.vue
// module id = null
// module chunks = 